import { useState, useEffect } from 'react';
import Api from "../../../services/api";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import {END_DATE, getDates, START_DATE} from '../../../utility';
import Plot from "react-plotly.js";
import { toast } from 'react-toastify';
import DateComponent from '../../../components/datepicker';

function AppTracking(){
  const navigate = useNavigate();
  const app  = useSelector((state) => state.app.data);

  const [trackingEvents,setTrackingEvents] = useState([]);
  const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
  const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));
  const [plot,setPlot] = useState({});

  const { code, os } = useParams();
  let dates = getDates(startDate,endDate);
  const plotTitle = Object.keys(trackingEvents[Object.keys(trackingEvents)[0]] || []) ;

  useEffect(() => {
    Api.get(`api/tracking?os=${os}&from=${startDate.format('YYYY-MM-DD')}&to=${endDate.format('YYYY-MM-DD')}&code=${code}`)
    .then(result => {
      if(result.data.code == 0)
        setTrackingEvents(result.data.data)
      else
        toast.error("Lỗi lấy dữ liệu !!");
      });
  }, [startDate,endDate,code,os]);

  useEffect(() => {
  	let plots = transformData(trackingEvents);
    setPlot(plots)
  }, [trackingEvents]);

  const transformData = () => {
  	return Object.entries(trackingEvents).map(([k,i]) => {
  		return {
	      type: "funnel",
        name : k,
	      y: plotTitle,
	      x: Object.values(i),
	      textinfo: "value+percent initial",
	      textposition: "inside",
	    }
  	})
  }

  const handleChangeDate = (event, picker) => {
    setStartDate(picker.startDate)
    setEndDate(picker.endDate)
  }

	return (
    <>
      <section className="main__filter" >
        <div className="filter">
            <div className="container-fluid">
                <form action="" method="get" id="form">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-10">
                            <div className="title-head-box">
                                <p className="title-block">Tracking</p>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                                <div className="filter-sticky">
                                    <div className="d-flex justify-content-end">
                                        <DateComponent startDate={startDate} endDate={endDate} handleChangeDate={handleChangeDate} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
      </section>
      <section className="main__content">
        <div className="container-fluid">
          <div className="row justify-content-between">
        		<Plot
              data={plot}
              layout={{
                title: "Biểu đồ",
                funnelmode: "stack",
              }}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </section>
    </>
	)
}
export default AppTracking;